import { render, staticRenderFns } from "./Distance.vue?vue&type=template&id=28023735&"
import script from "./Distance.vue?vue&type=script&lang=js&"
export * from "./Distance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports